<ng-container
  *ngIf="{
    globalSettings: globalSettings$ | async,
    orderSelectedPlan: orderSelectedPlan$ | async
  } as data"
>
  <ng-template #firstPrice let-displayItem>
    <span class="first">{{ product[displayItem].first | price }} </span>
    <span
      class="single-payment"
      *ngIf="
        !haveRebilling(product, data.globalSettings) &&
        data.orderSelectedPlan.billing_type !== 'single_payment' &&
        product[displayItem].first[
          data.globalSettings.is_vat_shown ? 'net' : 'gross'
        ] >= 0.01
      "
      i18n="@@product-price.pay_once"
      >einmalig</span
    >
  </ng-template>

  <ng-template #otherPrice let-displayItem>
    <span
      class="interval"
      *ngIf="!withoutInterval && haveRebilling(product, data.globalSettings)"
    >
      <span
        class="plus-amount"
        *ngIf="
          showOtherRebillingAmount(
            product,
            data.orderSelectedPlan,
            data.globalSettings
          );
          else showWithoutPlus
        "
      >
        +<ng-container *ngTemplateOutlet="showWithoutPlus"></ng-container>
      </span>
      <ng-template #showWithoutPlus>
        <span class="price">{{ product[displayItem].oth | price }}</span>
      </ng-template>
      <span class="unit"> {{ data.orderSelectedPlan.interval_unit }}</span>
    </span>
  </ng-template>

  <ng-container
    *ngIf="
      showDiscount &&
        (product[display].first.gross !== product[displayDiscount].first.gross
          ? !(product[display].oth.gross !== product[displayDiscount].oth.gross)
          : product[display].oth.gross !== product[displayDiscount].oth.gross);
      else displayBothDiscount
    "
  >
    <span
      class="undiscounted"
      *ngIf="
        showDiscount &&
        product[display].first.gross !== product[displayDiscount].first.gross
      "
    >
      <ng-template
        *ngTemplateOutlet="firstPrice; context: { $implicit: displayDiscount }"
      ></ng-template>
    </span>
    <ng-template
      *ngTemplateOutlet="firstPrice; context: { $implicit: display }"
    ></ng-template>

    <span
      class="undiscounted"
      *ngIf="
        showDiscount &&
        product[display].oth.gross !== product[displayDiscount].oth.gross
      "
    >
      <ng-template
        *ngTemplateOutlet="otherPrice; context: { $implicit: displayDiscount }"
      ></ng-template>
    </span>
    <ng-template
      *ngTemplateOutlet="otherPrice; context: { $implicit: display }"
    ></ng-template>
  </ng-container>

  <ng-template #displayBothDiscount>
    <span
      class="undiscounted"
      *ngIf="
        showDiscount &&
        product[display].first.gross !== product[displayDiscount].first.gross
      "
    >
      <ng-template
        *ngTemplateOutlet="firstPrice; context: { $implicit: displayDiscount }"
      ></ng-template>
      <ng-template
        *ngTemplateOutlet="otherPrice; context: { $implicit: displayDiscount }"
      ></ng-template>
    </span>
    <ng-template
      *ngTemplateOutlet="firstPrice; context: { $implicit: display }"
    ></ng-template>
    <ng-template
      *ngTemplateOutlet="otherPrice; context: { $implicit: display }"
    ></ng-template>
  </ng-template>
</ng-container>
